<div class="login-wrapper flex justify-content-center align-items-center">
  <div class="w-500px" *ngIf="!initializing"></div>
  <ng-container *ngIf="initializing">
    <div class="flex flex-column align-items-center w-500px">
      <h2>Accesso in corso...</h2>
      <p-progressSpinner></p-progressSpinner>
    </div>
  </ng-container>
</div>
